module.exports = __webpack_public_path__ + "static/media/expandArrow.d614e3ef.svg";